import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Link } from 'react-router-dom';
import { Row, Col, Container, Card, CardBody, CardTitle, Modal, Form, Label, Input, UncontrolledDropdown } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import axios from 'axios';
import * as url from 'helpers/url_helper';
import { Config, TOAST_OPTIONS, validateSomaliaPhoneNumber } from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import { Button,  DropdownToggle,  DropdownMenu,  DropdownItem,  ButtonDropdown, Table} from "reactstrap";
import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'
import Swal from 'sweetalert2';

    const ComplaintsCategories = () => {

        toastr.options = TOAST_OPTIONS;
        const [modal_categories, setmodal_categories] = useState(false);
        const [modal_handler, setmodal_handler] = useState(false);
        const [modal_dept, setmodal_dept] = useState(false);
        const [isEdit, setIsEdit] = useState(false);
        const [categories, setCategories] = useState([])
        const [handlers, setHandlers] = useState([])
        const [depts, setDepts] = useState([])
        const [isLoading, setIsLoading] = useState(false)

        const [deptId, setDeptId] = useState('')
        const [deptName, setDeptName] = useState('')

        const [complaintName, setComplaintName] = useState('')
        const [complaintId, setComplaintId] = useState('')

        const [handlerId, setHandlerId] = useState('')
        const [handlerName, setHandlerName] = useState('')
        const [handlerPhone, setHandlerPhone] = useState('')
        const [handlerEmail, setHandlerEmail] = useState('')
        const [handlerStatus, setHandlerStatus] = useState('')
        const [handlerDept, setHandlerDept] = useState('')
        const [h, setH] = useState(["Billing department","Meter reading department","Technical department","Field technician"])
        

        const removeBodyCss = () => {
          document.body.classList.add("no_padding");
        }
        const tog_categories = () => {
          fetchData()
          setmodal_categories(!modal_categories)
          removeBodyCss()
        }
        const tog_handler = () => {
          fetchData()
          setmodal_handler(!modal_handler)
          removeBodyCss()
        }
        const tog_dept = () => {
          fetchData()
          setmodal_dept(!modal_dept)
          removeBodyCss()
        }
        const fetchData = () => {
          setIsLoading(true)
          axios.get(url.COMPLAINTCATEGORIES, Config).then((r)=>{ 
            setCategories(r.data)
            //console.log(r)
            setIsLoading(false)
          }).catch((e)=>{  
            console.log(e); 
            setIsLoading(false)
          });
          axios.get(url.HANDLERS, Config).then((r)=>{ 
            setHandlers(r.data);
            //console.log(r.data)
          }).catch((e)=>{  
            console.log(e);
          });
          axios.get(url.DEPTS, Config).then((r)=>{ 
            setDepts(r.data);
          }).catch((e)=>{  
            console.log(e);
          });
        }
        
        useEffect(() => {
          fetchData();
        },[]);

        const handleSaveDept = () =>{
          if(deptName.trim().length < 2){
            toastr.error("Enter department name")
          }else{
            let data = {}
            if(isEdit){
              data = {
                id: deptId,
                name: deptName,
                action: "edit"
              }
            }else{
              data = {
                name: deptName,
                action: "add"
              }
            }
            
            setIsLoading(true)
            axios.post(url.DEPTS, JSON.stringify(data), Config).then((r)=>{
              if(r.data.status == '1'){
                toastr.success(r.data.message)
                tog_dept()
                setIsEdit(false)
                setDeptName('')
              }else{
                toastr.error(r.data.message)
              }
              setIsLoading(false)
            }).catch((e)=>{
              console.log(e)
              setIsLoading(false)
            })
          }
        }
        const handleSaveCategory = () =>{
          if(complaintName.trim().length < 2){
            toastr.error("Enter complaint category name")
          }else if(handlerDept.length < 1){
            toastr.error("Select complaint category handler")
          }else{
            let data = {}
            if(isEdit){
              data = {
                id: complaintId,
                name: complaintName,
                handler: handlerDept,
                action: "edit"
              }
            }else{
              data = {
                name: complaintName,
                handler: handlerDept,
                action: "add"
              }
            }
            
            setIsLoading(true)
            axios.post(url.COMPLAINTCATEGORIES, JSON.stringify(data), Config).then((r)=>{
              if(r.data.status == '1'){
                toastr.success(r.data.message)
                tog_categories()
                setIsEdit(false)
                setComplaintName('')
                setHandlerDept('')
              }else{
                toastr.error(r.data.message)
              }
              setIsLoading(false)
            }).catch((e)=>{
              console.log(e)
              setIsLoading(false)
            })
          }
        }
        const handleAddHandler = () =>{
          if(handlerName.trim().length < 3){
            toastr.error("Enter handler name")
          }else if((handlerPhone.trim().length != 13) || validateSomaliaPhoneNumber(handlerPhone)){
            toastr.error("Enter valid handler's phone number e.g +252634473173")
          }else if(handlerEmail.trim().length < 5){
            toastr.error("Enter handler email address")
          }else{
            let data = {}
            if(isEdit){
              data = {
                id: handlerId,
                name: handlerName,
                phone: handlerPhone,
                email: handlerEmail,
                dept: handlerDept,
                status: handlerStatus,
                action: "edit"
              }
            }else{
              data = {
                name: handlerName,
                phone: handlerPhone,
                email: handlerEmail,
                dept: handlerDept,
                action: "add"
              }
            }
            setIsLoading(true)
            axios.post(url.HANDLERS, JSON.stringify(data), Config).then((r)=>{
              if(r.data.status == '1'){
                toastr.success(r.data.message)
                tog_handler()
                setIsEdit(false)
                setHandlerName('')
                setHandlerPhone('')
                setHandlerEmail('')
                setHandlerDept('')
                setHandlerStatus('')
              }else{
                toastr.error(r.data.message)
              }
              setIsLoading(false)
            }).catch((e)=>{
              console.log(e)
              setIsLoading(false)
            })
          }
        }
        const handleClickAddDept = () =>{
          setIsEdit(false)
          tog_dept()
        } 
        const handleClickDeptDetails = (c) =>{
          setIsEdit(true)
          setDeptId(c.id)
          setDeptName(c.name)
          tog_dept()
        }
        const handleClickCategoryDetails = (c) =>{
          setIsEdit(true)
          setComplaintId(c.id)
          setComplaintName(c.name)
          setHandlerDept(c.handlerId)
          tog_categories()
        }
        const handleClickHandlerDetails =(c)=>{
          setIsEdit(true)
          setHandlerId(c.id)
          setHandlerPhone(c.phone)
          setHandlerName(c.name)
          setHandlerEmail(c.email)
          setHandlerDept(c.dept)
          setHandlerStatus(c.status)
          tog_handler()
        }
        const handleDeleteHandler = (c) =>{
          Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
          }).then((result) => {
            if (result.isConfirmed) {
              const data = {
                id: c.id,
                name: "item name to delete",
                action: "delete"
              }
              setIsLoading(true)
              axios.post(url.HANDLERS, JSON.stringify(data), Config).then((r)=>{
                if(r.data.status == '1'){
                  toastr.success(r.data.message)
                  fetchData()
                  setIsEdit(false)
                  setHandlerName('')
                  setHandlerPhone('')
                  setHandlerEmail('')
                  setHandlerDept('')
                  setHandlerStatus('')
                }else{
                  toastr.error(r.data.message)
                }
                setIsLoading(false)
              }).catch((e)=>{
                console.log(e)
                setIsLoading(false)
              })
            }
            
          })
        }
        const handleClickAddCategory = () =>{
          setIsEdit(false)
          tog_categories()
        }
        const handleAddNewHandler = () =>{
          setIsEdit(false)
          setHandlerName('')
          setHandlerPhone('')
          setHandlerEmail('')
          setHandlerDept('')
          setHandlerStatus('')
          tog_handler()
        }
        const handleDeleteCategory = (c) =>{
          Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
          }).then((result) => {
            if (result.isConfirmed) {
              const data = {
                id: c.id,
                name: "item name to delete",
                action: "delete"
              }
              setIsLoading(true)
              axios.post(url.COMPLAINTCATEGORIES, JSON.stringify(data), Config).then((r)=>{
                if(r.data.status == '1'){
                  toastr.success(r.data.message)
                  fetchData()
                  setIsEdit(false)
                  setComplaintName('')
                }else{
                  toastr.error(r.data.message)
                }
                setIsLoading(false)
              }).catch((e)=>{
                console.log(e)
                setIsLoading(false)
              })
            }
            
          })
        }
       

        return (
            <>
              <LoadingOverlay
                active={isLoading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Categories and Handlers | {url.COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Row>
                                      
                            <Col lg="4">
                            <Card>
                                <CardBody>
                                <div>
                                    <Row className="mb-3">
                                    <Col xl={6} sm={6}>
                                        <div className="mt-2">
                                        <h5>{`Departments`}</h5>
                                        </div>
                                    </Col>

                                <Modal isOpen={modal_dept} toggle={() => { tog_dept(); }}  size="l" centered  backdrop={'static'}  >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ isEdit? `Update Department`:`Add Department` }</h5>
                                    <button type="button"  onClick={() => { setmodal_dept(false);  }}  className="close" data-dismiss="modal"aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Department</label>
                                                <input type='text' className="form-control" value={deptName} onChange={(e)=>setDeptName(e.target.value)} />
                                            </div>
                                        </Col>
                                        
                                        
                                  </Row>
                                  </div>
                                  
                                  <div className="modal-footer">
                                  {isLoading ? 
                                        (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                                      : ( <button type="button" className="btn btn-success" onClick={()=>handleSaveDept()}>Save details</button> )
                                  }</div>
                                </Modal>
                                <Modal isOpen={modal_categories} toggle={() => { tog_categories(); }}  size="l" centered  backdrop={'static'}  >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ isEdit? `Update Complaint Category`:`Add Complaint Category` }</h5>
                                    <button type="button"  onClick={() => { setmodal_categories(false);  }}  className="close" data-dismiss="modal"aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Complaint Category</label>
                                                <input type='text' className="form-control" value={complaintName} onChange={(e)=>setComplaintName(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Handling department</label>
                                                <select className="form-select" value={handlerDept} onChange={(e)=>setHandlerDept(e.target.value)}>
                                                  <option value={``}></option>
                                                  {depts.map((x,k)=>(
                                                            <option key={k} value={x.id}>{x.name}</option>
                                                        ))}
                                                </select>
                                            </div>
                                        </Col>
                                        
                                        
                                  </Row>
                                  </div>
                                  
                                  <div className="modal-footer">
                                  {isLoading ? 
                                        (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                                      : ( <button type="button" className="btn btn-success" onClick={()=>handleSaveCategory()}>Save details</button> )
                                  }</div>
                                </Modal>

                                <Modal isOpen={modal_handler} toggle={() => { tog_handler(); }}  size="l" centered  backdrop={'static'}  >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ isEdit? `Update Handler`:`Add Complaint Handler` }</h5>
                                    <button type="button"  onClick={() => { setmodal_handler(false);  }}  className="close" data-dismiss="modal"aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Department</label>
                                                <select className="form-select" value={handlerDept} onChange={(e)=>setHandlerDept(e.target.value)}>
                                                  <option value={``}></option>
                                                  {h.map((x,k)=>(
                                                            <option key={k} value={x}>{x}</option>
                                                        ))}
                                                </select>
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Name</label>
                                                <input type='text' className="form-control" value={handlerName} onChange={(e)=>setHandlerName(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Phone number</label>
                                                <input type='text' className="form-control" value={handlerPhone} onChange={(e)=>setHandlerPhone(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Email</label>
                                                <input type='email' className="form-control" value={handlerEmail} onChange={(e)=>setHandlerEmail(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Status</label>
                                                <select className="form-control" value={handlerStatus} onChange={(e)=>setHandlerStatus(e.target.value)}>
                                                  <option value="Active">Active</option>
                                                  <option value="Deactivated">Deactivated</option>
                                                </select>
                                            </div>
                                        </Col>
                                  </Row>
                                  </div>
                                  
                                  <div className="modal-footer">
                                  {isLoading ? 
                                        (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                                      : ( <button type="button" className="btn btn-success" onClick={handleAddHandler}>Save details</button> )
                                  }</div>
                                </Modal>

                                    <Col xl={6} sm={6}>
                                        <Form className="mt-4 mt-sm-0 float-sm-end d-flex align-items-center">
                                        <div className="search-box mb-2 me-2">
                                           
                                        </div>

                                        <UncontrolledDropdown className="mb-0" direction="right">
                                            <DropdownToggle
                                            color="white"
                                            className="btn btn-link text-muted mt-n2"
                                            onClick={()=>{handleClickAddDept()}}
                                            >
                                            <i className="mdi mdi-book-plus-multiple font-size-24 text-success"></i>
                                            </DropdownToggle>

                                      
                                        </UncontrolledDropdown>
                                        </Form>
                                    </Col>
                                    </Row>
                                </div>
                                
                                <div className="table">
                                  <Table className="table table-sm m-0">
                                    <thead>
                                      <tr>
                                        <th>No</th>
                                        <th>Name</th>
                                        <th></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                    {depts.map((c,k)=>(
                                      <tr key={k}>
                                        <td>{k+1}</td>
                                        <td>{c.name}</td>
                                        <td>
                                        <div className="d-flex gap-3">
                                          <UncontrolledDropdown direction="left">
                                              <DropdownToggle href="#" className="card-drop" tag="i">
                                                <i className="mdi mdi-dots-horizontal font-size-18" />
                                              </DropdownToggle>
                                              <DropdownMenu className="dropdown-menu-end">
                                          
                                                <DropdownItem onClick={()=>{handleClickDeptDetails(c)}}>
                                                  <i className="fas fa-address-card text-warning me-1" />
                                                  {` `} Department 
                                                </DropdownItem>
                                        
                                              </DropdownMenu>
                                            </UncontrolledDropdown>
                                          </div>
                                        </td>
                                      </tr>
                                    ))} 
                                    </tbody>
                                                          
                                  </Table>
                                </div>

                                </CardBody>
                            </Card>
                            </Col>

                            <Col lg="8">
                            <Card>
                                <CardBody>
                                <div>
                                    <Row className="mb-3">
                                    <Col xl={6} sm={6}>
                                        <div className="mt-2">
                                        <h5>{`Complaint categories`}</h5>
                                        </div>
                                    </Col>
                                    <Col xl={6} sm={6}>
                                        <Form className="mt-4 mt-sm-0 float-sm-end d-flex align-items-center">
                                        <div className="search-box mb-2 me-2">
                                           
                                        </div>

                                        <UncontrolledDropdown className="mb-0" direction="right">
                                            <DropdownToggle
                                            color="white"
                                            className="btn btn-link text-muted mt-n2"
                                            onClick={()=>{handleClickAddCategory()}}
                                            >
                                            <i className="mdi mdi-book-plus-multiple font-size-24 text-success"></i>
                                            </DropdownToggle>

                                      
                                        </UncontrolledDropdown>
                                        </Form>
                                    </Col>
                                    </Row>
                                </div>
                                
                                <div className="table">
                                  <Table className="table table-sm m-0">
                                    <thead>
                                      <tr>
                                        <th>No</th>
                                        <th>Name</th>
                                        <th>Handler</th>
                                        <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Number of staff</th>
                                        <th></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                    {categories.map((c,k)=>(
                                      <tr key={k}>
                                        <td>{k+1}</td>
                                        <td>{c.name}</td>
                                        <td>{c.handler}</td>
                                        <td  style={{ verticalAlign: 'middle', textAlign: 'center' }}><b>{c.staff}</b></td>
                                        <td>
                                        <div className="d-flex gap-3">
                                          <UncontrolledDropdown direction="left">
                                              <DropdownToggle href="#" className="card-drop" tag="i">
                                                <i className="mdi mdi-dots-vertical font-size-18" />
                                              </DropdownToggle>
                                              <DropdownMenu className="dropdown-menu-end">
                                          
                                                <DropdownItem onClick={()=>{handleClickCategoryDetails(c)}}>
                                                  <i className="fas fa-address-card text-warning me-1" />
                                                  {` `} Category details
                                                </DropdownItem>
                                        
                                              </DropdownMenu>
                                            </UncontrolledDropdown>
                                          </div>
                                        </td>
                                      </tr>
                                    ))} 
                                    </tbody>
                                                          
                                  </Table>
                                </div>

                                </CardBody>
                            </Card>

                           
                            </Col>
                        </Row>

                        
                           

                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default ComplaintsCategories;